export const sampleObj = [
  {
    adult: false,
    backdrop_path: "/h8gHn0OzBoaefsYseUByqsmEDMY.jpg",
    genre_ids: [28, 53, 80],
    id: 603692,
    original_language: "en",
    original_title: "John Wick: Chapter 4",
    overview:
      "With the price on his head ever increasing, John Wick uncovers a path to defeating The High Table. But before he can earn his freedom, Wick must face off against a new enemy with powerful alliances across the globe and forces that turn old friends into foes.",
    popularity: 678.912,
    poster_path: "/vZloFAK7NmvMGKE7VkF5UHaz0I.jpg",
    release_date: "2023-03-22",
    title: "John Wick: Chapter 4",
    video: false,
    vote_average: 8.7,
    vote_count: 25,
  },
  {
    adult: false,
    backdrop_path: "/gslT8t964rYXyqRcqrxFh77ikyb.jpg",
    genre_ids: [12, 878, 35],
    id: 640146,
    original_language: "en",
    original_title: "Ant-Man and the Wasp: Quantumania",
    overview:
      "Super-Hero partners Scott Lang and Hope van Dyne, along with with Hope's parents Janet van Dyne and Hank Pym, and Scott's daughter Cassie Lang, find themselves exploring the Quantum Realm, interacting with strange new creatures and embarking on an adventure that will push them beyond the limits of what they thought possible.",
    popularity: 676.499,
    poster_path: "/ngl2FKBlU4fhbdsrtdom9LVLBXw.jpg",
    release_date: "2023-02-15",
    title: "Ant-Man and the Wasp: Quantumania",
    video: false,
    vote_average: 6.3,
    vote_count: 1140,
  },
  {
    adult: false,
    backdrop_path: "/sBOenwOZGRN5nZZGw4TxwtnfrEf.jpg",
    genre_ids: [28, 35, 80, 53],
    id: 899112,
    original_language: "en",
    original_title: "Violent Night",
    overview:
      "When a team of mercenaries breaks into a wealthy family compound on Christmas Eve, taking everyone inside hostage, the team isn’t prepared for a surprise combatant: Santa Claus is on the grounds, and he’s about to show why this Nick is no saint.",
    popularity: 336.135,
    poster_path: "/1XSYOP0JjjyMz1irihvWywro82r.jpg",
    release_date: "2022-11-30",
    title: "Violent Night",
    video: false,
    vote_average: 7.6,
    vote_count: 1329,
  },
];
